import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";

const InstagramButton = () => (
  <a
    className="floating-social-link floating-social-link--instagram"
    href="https://www.instagram.com/artofliving.yoga.london.on?mdxt=a2Jqa2kyeG9sbTE2&utm_source=ig_contact_invite"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Visit Art of Living Yoga London on Instagram"
    title="Instagram"
    style={{
      background: "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)",
      color: "white",
    }}
  >
    <InstagramIcon style={{ fontSize: 35 }} />
  </a>
);

export default InstagramButton;
